import { ANSIBLE_KEY } from './constants';

export const hashRoute = subpath => `#/${ANSIBLE_KEY}/${subpath}`;
export const route = subpath => hashRoute(subpath).substring(1);



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/components/AnsibleHostDetail/helpers.js